import { ReactNode } from 'react';
import { Flex, Grid, List, Space, Typography } from 'antd';
import { createStyles, useTheme } from 'antd-style';
import { ArrowCircleRightIcon } from '@phosphor-icons/react';
interface IAttributeTableProps {
  data: Array<{
    title: string;
    value: ReactNode;
    icon?: ReactNode;
  }>;
  columnCount?: 1 | 2 | 3 | 4;
  width?: string | number;
}

// antd buttons never wrap their text, so a long action button in a narrow value column (a phone,
// or a half-width card) would run past the row. Let it wrap like the text around it.
const useStyles = createStyles(() => ({
  value: {
    fontWeight: 'initial',
    flex: 1,
    minWidth: 0,
    overflowWrap: 'anywhere',
    '& .ant-btn': {
      whiteSpace: 'normal',
      height: 'auto',
      maxWidth: '100%',
      textAlign: 'left',
    },
  },
}));

export const AttributeTable = ({ data, columnCount = 1, width }: IAttributeTableProps) => {
  const token = useTheme();
  const { styles } = useStyles();
  // Phones give the value a little more room (40/60); wider screens keep the even split.
  const screens = Grid.useBreakpoint();
  const labelWidth = screens.sm === false ? '40%' : '50%';

  /*return (
    <Styles.Wrapper $columnCount={columnCount} style={style}>
      {data.map(item => (
        <Styles.Cell key={item.title} $columnCount={columnCount}>
          <Flex gap={8} align="center" style={{ width: '50%' }}>
            {item.icon ? (
              item.icon
            ) : (
              <ArrowCircleRightIcon style={{ color: token.colorPrimary }} />
            )}
            <Styles.Label>{item.title}</Styles.Label>
          </Flex>
          <Typography.Text style={{ fontWeight: 'bold' }}>
            {item.value ? item.value : '-'}
          </Typography.Text>
        </Styles.Cell>
      ))}
    </Styles.Wrapper>
  );*/

  return (
    <List
      // Phones get one column and tablets at most two: at 375px a two-column list left each label a
      // few pixels and rendered it one letter per line.
      grid={{
        gutter: 8 * columnCount,
        column: columnCount,
        xs: 1,
        sm: 1,
        md: Math.min(columnCount, 2),
      }}
      dataSource={data}
      style={{
        borderTop: `1px solid ${token.colorBorderSecondary}`,
        width: width,
      }}
      renderItem={item => (
        <List.Item
          style={{
            borderBottom: `1px solid ${token.colorBorderSecondary}`,
            padding: 8,
          }}
        >
          <Flex vertical={false} justify="flex-start" style={{ minWidth: 0 }}>
            {/* The label keeps its half of the row; a long value wraps instead of squeezing it. */}
            <Space size={'middle'} style={{ width: labelWidth, flexShrink: 0 }}>
              <div>{item.icon ? item.icon : <ArrowCircleRightIcon />}</div>
              <Typography.Text type="secondary">{item.title}</Typography.Text>
            </Space>
            <Typography.Text className={styles.value}>{item.value}</Typography.Text>
          </Flex>
        </List.Item>
      )}
    />
  );
};
